import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import UsersRoleSubProject from '../../../widgets/usersRoleSubProject/UsersRoleSubProject'

export default function ApprovalFormReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const mockSchema = {
    header: 'ตั้งค่าผู้ใช้งาน',
    subHeader: 'กำหนด Users role',
    form: {
      roleName: {
        header: 'Role Name',
        roleNameInput: {
          name: 'roleNameInput',
          label: 'Role Name',
          value: null,
          disabled: false,
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก Role Name' }],
        },
      },
      role: {
        header: 'Role',
        buttonText: {
          disabled: false,
          errorMessage: 'ไม่พบข้อมูล',
          saveButtonName: 'บันทึก',
          cancelButtonName: 'ยกเลิก',
        },
        list: {
          defaultValue: {
            title: 'Available',
            value: [],
            name: 'defaultValue',
            itemList: [
              {
                disabled: false,
                label: 'บันทึก/แก้ไข โครงการย่อย',
                name: 'checkbox1',
                value: '1',
              },
              {
                disabled: false,
                label: 'อนุมัติโครงการย่อย',
                name: 'checkbox2',
                value: '2',
              },
              {
                disabled: false,
                label: 'บันทึกงวดเงิน',
                name: 'checkbox3',
                value: '3',
              },
              {
                disabled: false,
                label: 'ปิดโครงการย่อย',
                name: 'checkbox4',
                value: '4',
              },
            ],
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณาเลือก Available',
              },
            ],
          },
          selectedValue: {
            title: 'Selected',
            name: 'selectedValue',
            value: [],
            itemList: [],
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณาเลือก selected',
              },
            ],
          },
        },
      },
    },
  }

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)

    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getProjectName(proposalId)
      setSchema(mockSchema)
      // setIsEditWidget({
      //   reportSetting: _schema.forms?.reportSetting?.id ? false : true,
      // })

      // setShowEditAll(!_schema.forms?.reportSetting?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <UsersRoleSubProject schema={schema.form} isEdit={true} />
        </SidebarProposal>
      )}
    </>
  )
}
